import {
  CROSS_DEVICE_OTT,
  LAST_ATTRIBUTED_TOUCH_DATA_TILDE_ADVERTISING_PARTNER_NAME,
  LAST_ATTRIBUTED_TOUCH_DATA_TILDE_CAMPAIGN_NAME,
  OTT,
} from '../../../../../shared/constants/cenariusDimensions';
import { QUICK_LINKS_DIMENSIONS_WHITE_LIST } from '../../../../../shared/constants/quickLinksDimensionsWhitelist';
import {
  ALL_DATA_VALUE,
  JOURNEYS_VALUE,
  OTT_VALUE,
  QUICK_LINKS_VALUE,
  UNIVERSAL_ADS_VALUE,
  UNIVERSAL_EMAIL_VALUE,
} from '../../../../../shared/constants/summary';
import { SUMMARY_DIMENSIONS_WHITE_LIST } from '../../../../../shared/constants/summaryDimensionsWhitelist';
import {
  CORE_EVENT_NAMES,
  EMAIL_ANALYTICS_DATASOURCES,
  JOURNEYS_ANALYTICS_DATASOURCES,
} from '../../../common/support/eo_mapping';
import { SUMMARY_ANALYTICS_DATASOURCES } from '../../../common/support/eo_mapping/datasources';
import { ALL_EVENT_NAMES_WITH_LOCAL_CURRENCY, ALL_NAMED_EVENT_NAMES } from '../../../common/support/eo_mapping/event_names';
import {
  ADS_TIMESERIES_SOURCE_QUERIES,
  EMAIL_SOURCE_QUERIES,
  QUICK_LINKS_SOURCE_QUERIES,
  SOURCE_QUERIES,
} from '../../../common/support/eo_mapping/source_queries';
import InFilter from '../../../common/support/utils/druid/filters/InFilter';
import { convertMultipleQueriesToNativeDruidFilters } from '../../../common/support/utils/druid/nativeQueries';
import { DEFAULT_DATA_SOURCES as ADS_DEFAULT_TRENDS_DATA_SOURCES } from '../ScreenAdsAnalytics/AdsTimeSeries/AdsTimeSeries.constants';
import { ADS_COMPARE_BY_DIMENSIONS, DATA_SOURCES as ADS_DATASOURCES, ADS_EVENT_LIST } from '../ScreenAdsAnalytics/constants';
import { EVENT_LIST as EMAIL_EVENT_LIST } from '../ScreenEmail/Analytics/EmailsTimeSeries/EmailsTimeSeries.constants';
import { EMAIL_FILTERS_LIST } from '../ScreenEmail/Analytics/utils';
import {
  DEFAULT_DATA_SOURCES as JOURNEYS_DEFAULT_DATA_SOURCES,
  EVENT_LIST as JOURNEYS_EVENT_LIST,
} from '../ScreenJourneys/Analytics/TimeSeries/JourneysTimeSeries.constants';
import { JOURNEYS_ANALYTICS_FILTERS_LIST } from '../ScreenJourneys/utils/journeyConstants';
import { OTT_ANALYTICS_EVENT_LIST, OTT_TRENDS_INITIAL_DATA_SOURCES } from '../ScreenOtt/Trends/trends.config';
import {
  OTT_ANALYTICS_DATASOURCES,
  OTT_ANALYTICS_FILTER_DIMENSIONS,
  OTT_ANALYTICS_REPORT_DEFAULT_DIMENSIONS,
  OTT_ANALYTICS_TRENDS_DEFAULT_DIMENSIONS,
} from '../ScreenOtt/ott.constants';
import { DEFAULT_QUICK_LINKS_DIMENSIONS, QUICK_LINKS_DATASOURCES } from '../ScreenQuickLinks/constants';
import type {
  ProductCompareByMapping,
  ProductEventListMapping,
  ProductHasOrganicToggleMapping,
  ProductHasWebOnlyToggleMapping,
  ProductReportDataSourcesMapping,
  ProductReportDefaultDimensionsMapping,
  ProductReportDefaultFilterMapping,
  ProductRequiredFilterMapping,
  ProductSourceQueryMapping,
  ProductTilesConfigMapping,
  ProductTrendsDataSourcesMapping,
  ProductTrendsDefaultDimensionsMapping,
  ProductTrendsDefaultFilterMapping,
  ProductValueLabelMapping,
  SummaryTileConfig,
} from './newSummaryTypes';

export * from './constants/endpointMappings';

// ---------------------- MISCELLANEOUS ---------------------- //
export const INIT_DEFAULT_RANGE = 7; // default date range will be last 7 days

export const SUMMARY_PAGE_STYLE_VARIANT = 'summary-page';
export const SUMMARY_PAGE_DOCS_LINK = 'https://help.branch.io/using-branch/docs/branch-summary-page';
// ---------------------- DEFAULT DIMENSIONS ---------------------- //
export const DEFAULT_DIMENSIONS = [LAST_ATTRIBUTED_TOUCH_DATA_TILDE_ADVERTISING_PARTNER_NAME];
export const DEFAULT_TRENDS_DATASOURCES = [CORE_EVENT_NAMES.INSTALL];
export const DEFAULT_TABLE_COLUMNS = [
  CORE_EVENT_NAMES.CLICK,
  CORE_EVENT_NAMES.INSTALL,
  CORE_EVENT_NAMES.OPEN,
  CORE_EVENT_NAMES.REINSTALL,
];
const EMPTY_DIMENSIONS = [];
// ---------------------- TRENDS CONSTANTS ---------------------- //
export const EVENT_LIST = Object.keys(ALL_EVENT_NAMES_WITH_LOCAL_CURRENCY);

// ---------------------- COMPARE BY AND FILTER DIMENSIONS ---------------------- //
export const COMPARE_BY_DIMENSIONS = SUMMARY_DIMENSIONS_WHITE_LIST.filter(
  (dimension) => dimension !== OTT && dimension !== CROSS_DEVICE_OTT
);

/**
 * Dimensions to be used for compare by when touch point analytics is enabled
 */
export const TOUCH_POINT_ANALYTICS_COMPARE_BY_DIMENSIONS = [
  'last_attributed_touch_data_dollar_marketing_title',
  'last_attributed_touch_data_tilde_campaign',
  'last_attributed_touch_data_tilde_feature',
  'last_attributed_touch_data_tilde_channel',
  'user_data_geo_country_en',
  'user_data_geo_region_en',
  'user_data_os',
  'last_attributed_touch_data_tilde_referring_browser',
  'last_attributed_touch_data_plus_referring_domain',
  'last_attributed_touch_data_tilde_tags',
  'last_attributed_touch_data_tilde_id',
];

// ---------------------- PRODUCT LABELS ---------------------- //
export const ALL_DATA_LABEL = 'All Data';
export const JOURNEYS_LABEL = 'Journeys';
export const QUICK_LINKS_LABEL = 'Quick Links';
export const UNIVERSAL_ADS_LABEL = 'Ads';
export const UNIVERSAL_EMAIL_LABEL = 'Email';
export const OTT_LABEL = 'OTT';
// ---------------------- REQUIRED FILTER DIMENSIONS ---------------------- //
export const JOURNEYS_FILTER_DIMENSION = 'last_attributed_touch_data_tilde_feature';
export const QUICK_LINKS_FILTER_DIMENSION = 'last_attributed_touch_data_tilde_id';
export const ADS_FILTER_DIMENSION = 'last_attributed_touch_data_tilde_feature';
// no required filter dimension for EMAIL
export const OTT_FILTER_DIMENSION = 'ott';
// --------------------------- REQUIRED FILTERS --------------------------- //
const JOURNEYS_REQUIRED_FILTER = new InFilter(JOURNEYS_FILTER_DIMENSION, ['journeys']);
const ADS_REQUIRED_FILTER = new InFilter(ADS_FILTER_DIMENSION, ['paid advertising']);
const QUICK_LINKS_REQUIRED_FILTER = {};
const EMAIL_REQUIRED_FILTER = {};
const OTT_REQUIRED_FILTER = new InFilter(OTT_FILTER_DIMENSION, ['true']);
// ---------------------------- SOURCE QUERIES ---------------------------- //
export const ALL_DATA_SOURCE_QUERY = convertMultipleQueriesToNativeDruidFilters(SOURCE_QUERIES);
export const JOURNEYS_SOURCE_QUERY = convertMultipleQueriesToNativeDruidFilters(SOURCE_QUERIES);
export const QUICK_LINKS_SOURCE_QUERY = convertMultipleQueriesToNativeDruidFilters(QUICK_LINKS_SOURCE_QUERIES);
export const ADS_SOURCE_QUERY = convertMultipleQueriesToNativeDruidFilters(SOURCE_QUERIES);
export const ADS_TIMESERIES_SOURCE_QUERY = convertMultipleQueriesToNativeDruidFilters(ADS_TIMESERIES_SOURCE_QUERIES); // special source query for ads timeseries

export const EMAIL_SOURCE_QUERY = convertMultipleQueriesToNativeDruidFilters(EMAIL_SOURCE_QUERIES);
export const OTT_SOURCE_QUERY = convertMultipleQueriesToNativeDruidFilters(SOURCE_QUERIES);
// ---------------------------- PRODUCT MAPPINGS ---------------------------- //
export const PRODUCT_VALUE_LABEL_MAPPING: ProductValueLabelMapping = {
  [ALL_DATA_VALUE]: ALL_DATA_LABEL,
  [JOURNEYS_VALUE]: JOURNEYS_LABEL,
  [QUICK_LINKS_VALUE]: QUICK_LINKS_LABEL,
  [UNIVERSAL_ADS_VALUE]: UNIVERSAL_ADS_LABEL,
  [UNIVERSAL_EMAIL_VALUE]: UNIVERSAL_EMAIL_LABEL,
  [OTT_VALUE]: OTT_LABEL,
};
export const PRODUCT_REQUIRED_FILTER_MAPPING: ProductRequiredFilterMapping = {
  [ALL_DATA_VALUE]: {},
  [JOURNEYS_VALUE]: JOURNEYS_REQUIRED_FILTER,
  [QUICK_LINKS_VALUE]: QUICK_LINKS_REQUIRED_FILTER,
  [UNIVERSAL_ADS_VALUE]: ADS_REQUIRED_FILTER,
  [UNIVERSAL_EMAIL_VALUE]: EMAIL_REQUIRED_FILTER,
  [OTT_VALUE]: OTT_REQUIRED_FILTER,
};
export const PRODUCT_SOURCE_QUERY_MAPPING: ProductSourceQueryMapping = {
  [ALL_DATA_VALUE]: ALL_DATA_SOURCE_QUERY,
  [JOURNEYS_VALUE]: JOURNEYS_SOURCE_QUERY,
  [QUICK_LINKS_VALUE]: QUICK_LINKS_SOURCE_QUERY,
  [UNIVERSAL_ADS_VALUE]: ADS_SOURCE_QUERY,
  [UNIVERSAL_EMAIL_VALUE]: EMAIL_SOURCE_QUERY,
  [OTT_VALUE]: OTT_SOURCE_QUERY,
};

export const PRODUCT_HAS_WEB_ONLY_TOGGLE_MAPPING: ProductHasWebOnlyToggleMapping = {
  [ALL_DATA_VALUE]: true,
  [JOURNEYS_VALUE]: false,
  [QUICK_LINKS_VALUE]: true,
  [UNIVERSAL_ADS_VALUE]: false,
  [UNIVERSAL_EMAIL_VALUE]: false,
  [OTT_VALUE]: false,
};

export const PRODUCT_HAS_ORGANIC_TOGGLE_MAPPING: ProductHasOrganicToggleMapping = {
  [ALL_DATA_VALUE]: true,
  [JOURNEYS_VALUE]: false,
  [QUICK_LINKS_VALUE]: false,
  [UNIVERSAL_ADS_VALUE]: true,
  [UNIVERSAL_EMAIL_VALUE]: false,
  [OTT_VALUE]: true,
};

export const PRODUCT_COMPARE_BY_MAPPING: ProductCompareByMapping = {
  [ALL_DATA_VALUE]: [...COMPARE_BY_DIMENSIONS],
  [JOURNEYS_VALUE]: [...JOURNEYS_ANALYTICS_FILTERS_LIST],
  [QUICK_LINKS_VALUE]: [...QUICK_LINKS_DIMENSIONS_WHITE_LIST],
  [UNIVERSAL_ADS_VALUE]: ADS_COMPARE_BY_DIMENSIONS,
  [UNIVERSAL_EMAIL_VALUE]: EMAIL_FILTERS_LIST,
  [OTT_VALUE]: OTT_ANALYTICS_FILTER_DIMENSIONS,
};

export const PRODUCT_EVENT_LIST_MAPPING: ProductEventListMapping = {
  [ALL_DATA_VALUE]: EVENT_LIST,
  [JOURNEYS_VALUE]: JOURNEYS_EVENT_LIST,
  [QUICK_LINKS_VALUE]: EVENT_LIST,
  [UNIVERSAL_ADS_VALUE]: ADS_EVENT_LIST,
  [UNIVERSAL_EMAIL_VALUE]: EMAIL_EVENT_LIST,
  [OTT_VALUE]: OTT_ANALYTICS_EVENT_LIST,
};

export const PRODUCT_DATA_SOURCES_REPORT_MAPPING: ProductReportDataSourcesMapping = {
  [ALL_DATA_VALUE]: SUMMARY_ANALYTICS_DATASOURCES,
  [JOURNEYS_VALUE]: JOURNEYS_ANALYTICS_DATASOURCES,
  [QUICK_LINKS_VALUE]: QUICK_LINKS_DATASOURCES,
  [UNIVERSAL_ADS_VALUE]: ADS_DATASOURCES,
  [UNIVERSAL_EMAIL_VALUE]: EMAIL_ANALYTICS_DATASOURCES,
  [OTT_VALUE]: OTT_ANALYTICS_DATASOURCES,
};

export const PRODUCT_DATA_SOURCES_TRENDS_MAPPING: ProductTrendsDataSourcesMapping = {
  [ALL_DATA_VALUE]: DEFAULT_TRENDS_DATASOURCES,
  [JOURNEYS_VALUE]: JOURNEYS_DEFAULT_DATA_SOURCES,
  [QUICK_LINKS_VALUE]: DEFAULT_TRENDS_DATASOURCES,
  [UNIVERSAL_ADS_VALUE]: ADS_DEFAULT_TRENDS_DATA_SOURCES,
  [OTT_VALUE]: OTT_TRENDS_INITIAL_DATA_SOURCES,
};

export const PRODUCT_REPORT_DEFAULT_DIMENSIONS_MAPPING: ProductReportDefaultDimensionsMapping = {
  [ALL_DATA_VALUE]: DEFAULT_DIMENSIONS,
  [JOURNEYS_VALUE]: ['last_attributed_touch_data_tilde_journey_name'],
  [QUICK_LINKS_VALUE]: DEFAULT_QUICK_LINKS_DIMENSIONS,
  [UNIVERSAL_ADS_VALUE]: [
    LAST_ATTRIBUTED_TOUCH_DATA_TILDE_ADVERTISING_PARTNER_NAME,
    LAST_ATTRIBUTED_TOUCH_DATA_TILDE_CAMPAIGN_NAME,
  ],
  [UNIVERSAL_EMAIL_VALUE]: [LAST_ATTRIBUTED_TOUCH_DATA_TILDE_CAMPAIGN_NAME],
  [OTT_VALUE]: OTT_ANALYTICS_REPORT_DEFAULT_DIMENSIONS,
};

export const PRODUCT_REPORT_DEFAULT_FILTER_MAPPING: ProductReportDefaultFilterMapping = {
  [ALL_DATA_VALUE]: null,
  [JOURNEYS_VALUE]: null,
  [QUICK_LINKS_VALUE]: null,
  [UNIVERSAL_ADS_VALUE]: null,
  [UNIVERSAL_EMAIL_VALUE]: null,
  [OTT_VALUE]: null,
};

export const PRODUCT_TRENDS_DEFAULT_DIMENSIONS_MAPPING: ProductTrendsDefaultDimensionsMapping = {
  [ALL_DATA_VALUE]: EMPTY_DIMENSIONS,
  [JOURNEYS_VALUE]: ['last_attributed_touch_data_tilde_journey_name'],
  [QUICK_LINKS_VALUE]: DEFAULT_QUICK_LINKS_DIMENSIONS,
  [UNIVERSAL_ADS_VALUE]: [LAST_ATTRIBUTED_TOUCH_DATA_TILDE_ADVERTISING_PARTNER_NAME],
  [UNIVERSAL_EMAIL_VALUE]: [LAST_ATTRIBUTED_TOUCH_DATA_TILDE_CAMPAIGN_NAME],
  [OTT_VALUE]: OTT_ANALYTICS_TRENDS_DEFAULT_DIMENSIONS,
};

export const PRODUCT_TRENDS_DEFAULT_FILTER_MAPPING: ProductTrendsDefaultFilterMapping = {
  [ALL_DATA_VALUE]: null,
  [JOURNEYS_VALUE]: null,
  [QUICK_LINKS_VALUE]: null,
  [UNIVERSAL_ADS_VALUE]: null,
  [UNIVERSAL_EMAIL_VALUE]: null,
  [OTT_VALUE]: null,
};

// ---------------------------- INIT TILE CONFIGS ---------------------------- //
export const INIT_ALL_DATA_TILE_CONFIG: SummaryTileConfig = {
  'summary-tile-0': {
    dataSource: 'eo_click',
    filter: {},
    organic: false,
    unique: true,
  },
  'summary-tile-1': {
    dataSource: 'eo_impression',
    filter: {},
    organic: false,
    unique: true,
  },
  'summary-tile-2': {
    dataSource: 'eo_install',
    filter: {},
    organic: false,
    unique: true,
  },
  'summary-tile-3': {
    dataSource: 'eo_open',
    filter: {},
    organic: false,
    unique: true,
  },
};

export const INIT_JOURNEYS_TILE_CONFIG: SummaryTileConfig = {
  'summary-tile-0': {
    dataSource: 'eo_click',
    filter: {},
    organic: false,
    unique: true,
  },
  'summary-tile-1': {
    dataSource: 'eo_install',
    filter: {},
    organic: false,
    unique: true,
  },
  'summary-tile-2': {
    dataSource: 'eo_open',
    filter: {},
    organic: false,
    unique: true,
  },
  'summary-tile-3': {
    dataSource: 'eo_dismissal',
    filter: {},
    organic: false,
    unique: true,
  },
};

export const INIT_QUICK_LINKS_TILE_CONFIG: SummaryTileConfig = {
  'summary-tile-0': {
    dataSource: 'eo_click',
    filter: {},
    organic: false,
    unique: true,
  },
  'summary-tile-1': {
    dataSource: 'eo_install',
    filter: {},
    organic: false,
    unique: true,
  },
  'summary-tile-2': {
    dataSource: 'eo_open',
    filter: {},
    organic: false,
    unique: true,
  },
  'summary-tile-3': {
    dataSource: 'eo_reinstall',
    filter: {},
    organic: false,
    unique: true,
  },
};

export const INIT_UNIVERSAL_ADS_TILE_CONFIG: SummaryTileConfig = {
  'summary-tile-0': {
    dataSource: 'eo_click',
    filter: {},
    organic: false,
    unique: true,
  },
  'summary-tile-1': {
    dataSource: 'eo_impression',
    filter: {},
    organic: false,
    unique: true,
  },
  'summary-tile-2': {
    dataSource: 'eo_install',
    filter: {},
    organic: false,
    unique: true,
  },
  'summary-tile-3': {
    dataSource: 'eo_open',
    filter: {},
    organic: false,
    unique: true,
  },
};

export const INIT_UNIVERSAL_EMAIL_TILE_CONFIG: SummaryTileConfig = {
  'summary-tile-0': {
    dataSource: 'eo_click',
    filter: {},
    organic: false,
    unique: true,
  },
  'summary-tile-1': {
    dataSource: 'eo_install',
    filter: {},
    organic: false,
    unique: true,
  },
  'summary-tile-2': {
    dataSource: 'eo_open',
    filter: {},
    organic: false,
    unique: true,
  },
  'summary-tile-3': {
    dataSource: 'eo_reinstall',
    filter: {},
    organic: false,
    unique: true,
  },
};

export const PRODUCT_TILES_MAPPING: ProductTilesConfigMapping = {
  [ALL_DATA_VALUE]: INIT_ALL_DATA_TILE_CONFIG,
  [JOURNEYS_VALUE]: INIT_JOURNEYS_TILE_CONFIG,
  [QUICK_LINKS_VALUE]: INIT_QUICK_LINKS_TILE_CONFIG,
  [UNIVERSAL_ADS_VALUE]: INIT_UNIVERSAL_ADS_TILE_CONFIG,
  [UNIVERSAL_EMAIL_VALUE]: INIT_UNIVERSAL_EMAIL_TILE_CONFIG,
  [OTT_VALUE]: INIT_ALL_DATA_TILE_CONFIG,
};

// ---------------------------- TILE EVENT LIST ---------------------------- //
export const TILE_EVENT_LIST = Object.keys(ALL_NAMED_EVENT_NAMES);
